import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Badge,
  Divider,
  ListItemIcon,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

export default function NavbarMobile({
  cartCount,
  isActive,
  navigate,
  onLogout,
  onAccount,
}) {
  const [open, setOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("is_logged_in") === "true"
  );

  const toggle = (v) => () => setOpen(v);

  useEffect(() => {
    const syncAuth = () => {
      setIsLoggedIn(localStorage.getItem("is_logged_in") === "true");
    };
    syncAuth();
    window.addEventListener("storage", syncAuth);
    window.addEventListener("auth-change", syncAuth);
    return () => {
      window.removeEventListener("storage", syncAuth);
      window.removeEventListener("auth-change", syncAuth);
    };
  }, []);

  return (
    <>
      <button className="menu-trigger" onClick={toggle(true)}>
        <MenuIcon />
        <span className="menu-word">MENÚ</span>
      </button>

      <Drawer
        anchor="left"
        open={open}
        onClose={toggle(false)}
        PaperProps={{
          sx: {
            background: "#E6F0FA",
            color: "#003366",
            width: 300,
          },
        }}
      >
        <Box sx={{ width: "100%", padding: "12px" }}>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              justifyContent: "flex-start",
              padding: "4px 10px",
            }}
          >
            <IconButton
              onClick={() => {
                navigate("/shop");
                setOpen(false);
              }}
              sx={{ color: "#003366" }}
            >
              <Badge badgeContent={cartCount} color="error">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
          </Box>

          <Divider sx={{ my: 1, borderColor: "#9bb4c9" }} />

          <List>
            {[
              { label: "Inicio", path: "/" },
              { label: "Servicios", path: "/servicios" },
              { label: "Club Hydroluz", path: "/club-hydroluz" },
              { label: "Tienda", path: "/categorias" },
              { label: "Ofertas", path: "/ofertas" },
              { label: "Contactos", path: "/contactos" },
            ].map((item) => (
              <ListItemButton
                key={item.path}
                selected={isActive(item.path)}
                onClick={() => {
                  navigate(item.path);
                  setOpen(false);
                }}
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "rgba(0,51,102,0.12)",
                  },
                  "& .MuiListItemText-primary": {
                    fontSize: "1rem",
                    color: "#003366",
                  },
                }}
              >
                <ListItemText primary={item.label} />
              </ListItemButton>
            ))}
          </List>

          {isLoggedIn && (
            <>
              <Divider sx={{ my: 1, borderColor: "#9bb4c9" }} />
              <List>
                <ListItemButton
                  onClick={() => {
                    onAccount();
                    setOpen(false);
                  }}
                >
                  <ListItemIcon sx={{ color: "#003366" }}>
                    <AccountCircleIcon />
                  </ListItemIcon>
                  <ListItemText primary="Mi Cuenta" />
                </ListItemButton>

                <ListItemButton
                  onClick={async () => {
                    await onLogout();
                    setOpen(false);
                  }}
                >
                  <ListItemText primary="Cerrar Sesión" />
                </ListItemButton>
              </List>
            </>
          )}
        </Box>
      </Drawer>
    </>
  );
}
